/**
 * "table" structure is dependant on
 * group by. Each response of "g1" key (group by's value)
 * changes according to the grouping selected.
 *
 * Type:
 * key - Should be same as group by's id
 * value - object of {
 * 		type - 'string' | 'array' | 'object'
 * 		name - string or function that returns a string
 * 		id - id or function that returns and array of ids
 * }
 *
 * See "job" and "job_hiring_manager" for examples
 */
export const GROUP_BY_COLUMN_MAPPING = {
  application_source: {
    type: 'object',
    name: 'name',
    id: 'ext_id',
  },
  application_source_type: {
    type: 'string',
    name: (data) => data,
    id: (data) => data,
  },
  application_rejection_reason: {
    type: 'object',
    name: 'name',
    id: 'ext_id',
  },
  application_rejection_type: {
    type: 'string',
    name: (data) => data,
    id: (data) => data,
  },
  application_stage_outcome: {
    type: 'string',
    name: (data) => data,
    id: (data) => data,
  },

  job: {
    type: 'object',
    // Type is "object", so we display, the value of "name" from the object
    name: 'name',
    // Type is "object", so we display, id will be value of "ext_id" from the object
    id: 'ext_id',
  },
  job_status: {
    type: 'string',
    name: (data) => data,
    id: (data) => data,
  },
  job_sourcer: {
    type: 'array',
    name: (data) => {
      if (data?.length) {
        return data
          .map(({ first_name, last_name }) => `${first_name} ${last_name}`)
          .join(', ');
      }
    },
    id: (data) => {
      if (data.length) {
        return data.map(({ ext_id }) => ext_id);
      }
      return null;
    },
  },
  job_recruiter: {
    type: 'array',
    name: (data) => {
      if (data?.length) {
        return data
          .map(({ first_name, last_name }) => `${first_name} ${last_name}`)
          .join(', ');
      }
    },
    id: (data) => {
      if (data.length) {
        return data.map(({ ext_id }) => ext_id);
      }
      return null;
    },
  },
  job_hiring_manager: {
    type: 'array',
    // Type is an array of objects in a pre-determined format,
    // so, it will be function that maps and returns a string
    name: (data) => {
      if (data?.length) {
        return data
          .map(({ first_name, last_name }) => `${first_name} ${last_name}`)
          .join(', ');
      }
    },
    // Type is an array of objects in a pre-determined format,
    // so, id will be an array - this is important for making
    // the drilldown API call. This value should be passed as
    // it is.
    id: (data) => {
      if (data.length) {
        return data.map(({ ext_id }) => ext_id);
      }
      return null;
    },
  },
  job_department: {
    type: 'object',
    name: 'name',
    id: 'ext_id',
  },
  job_subdepartment: {
    type: 'object',
    name: 'name',
    id: 'ext_id',
  },
  job_office: {
    type: 'object',
    name: 'name',
    id: 'ext_id',
  },
  job_suboffice: {
    type: 'object',
    name: 'name',
    id: 'ext_id',
  },

  candidate_gender: {
    type: 'string',
    name: (data) => data,
    id: (data) => data,
  },
  candidate_recruiter: {
    type: 'object',
    name: (data) => `${data?.first_name ?? ''} ${data?.last_name ?? ''}`,
    id: 'ext_id',
  },
};

export const getValueForColumn = (key, obj) => {
  if (GROUP_BY_COLUMN_MAPPING[key]) {
    const { name, id, type } = GROUP_BY_COLUMN_MAPPING[key];

    return {
      name:
        (typeof name === 'function'
          ? name(obj ?? '')
          : obj?.[name]
        )?.trim?.() || 'Unknown',
      id:
        (typeof id === 'function' ? id(obj ?? '') : obj?.[id]) ||
        (type === 'array' ? null : '-1'),
    };
  }
};
